module.exports = __webpack_public_path__ + "static/media/hair.5db3c070.md";